module.exports = __webpack_public_path__ + "static/img/b3_body.b05ad1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/childrens/b3_body.png
// module id = 1rFk
// module chunks = 1